import { HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { transformarFechasFormatoAISO, transformarFechasISOAFormato } from '../utils/fechas-utils';
import { map } from 'rxjs/operators';

export const fechasInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {

  
  let body = req.body;
  if (body && !(body instanceof FormData)) {
      body = transformarFechasFormatoAISO(body);
  }

  const clonedReq = req.clone({ body });

  return next(clonedReq).pipe(
      map((event) => {
          if (event instanceof HttpResponse && event.body && typeof event.body === 'object') {
              const newBody = transformarFechasISOAFormato(event.body);
              return event.clone({ body: newBody });
          }
          return event;
      })
  );
}